package com.eladfinish.bible.contest.platform.clipboard

import androidx.compose.runtime.Composable

@Composable
actual fun ObserveClipboardTextWhileStarted(
    onTextCopied: (String) -> Unit,
) {
    // Intentionally empty. A page isn't told when the clipboard changes, and reading it to find
    // out makes the browser ask the user for permission. The copy options this would open are
    // still reached through the selected text's own Copy action (BrowseChaptersAction.CopySelectedText).
}
